import { graphql } from 'gql';

export const bimContractOtherCostViewGql = graphql(`
    query bimContractOtherCostView($contractOtherCostId: Long!) {
        bimContractOtherCost(contractOtherCostId: $contractOtherCostId) {
            data {
                calculatingType
                calculatingTypeValue
                chapter
                formula
                isGlobalOtherCost
                name
                otherCostLimits {
                    constructionType {
                        id
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    cost
                }
                status
                catalogOtherCostType {
                    id
                    uniqueId
                    name
                    canDelete
                    isSystem
                }
            }
        }
    }
`);

export const bimWorkOrderOtherDataViewGql = graphql(`
    query bimWorkOrderOtherDataView($workOrderOtherPriceId: Long!) {
        bimWorkOrderOtherData(workOrderOtherPriceId: $workOrderOtherPriceId) {
            data {
                calculatingType
                calculatingTypeValue
                chapter
                formula
                isGlobalOtherCost
                name
                otherCostLimits {
                    constructionType {
                        id
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    cost
                }
                status
                catalogOtherCostType {
                    id
                    uniqueId
                    name
                    canDelete
                    isSystem
                }
            }
        }
    }
`);

export const bimWorkOrderVersionOtherDataGql = graphql(`
    query bimWorkOrderVersionOtherData($workOrderVersionOtherPriceId: Long!) {
        bimWorkOrderVersionOtherData(workOrderVersionOtherPriceId: $workOrderVersionOtherPriceId) {
            data {
                calculatingType
                calculatingTypeValue
                chapter
                formula
                isGlobalOtherCost
                name
                otherCostLimits {
                    constructionType {
                        id
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    cost
                }
                status
                catalogOtherCostType {
                    id
                    uniqueId
                    name
                    canDelete
                    isSystem
                }
            }
        }
    }
`);

export const uerContractOtherCostViewGql = graphql(`
    query uerContractOtherCostView($contractId: Long!, $contractOtherCostId: Long!) {
        uerContractOtherCostForUpdate(contractId: $contractId, contractOtherCostId: $contractOtherCostId) {
            data {
                key
                calculatingType
                calculatingTypeValue
                chapter
                isGlobalOtherCost
                name
                groupConstructionLimits {
                    constructionType {
                        id
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    cost
                    distributionMethod
                    canEditLimitSpan
                    hasActualCost
                    hasLimitSpan
                }
                limits {
                    constructionType {
                        id
                        code
                        shortName
                        name
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    season {
                        id
                        year
                    }
                    cost
                }
                status
                formula
                catalogOtherCostType {
                    id
                    uniqueId
                    name
                    isSystem
                }
            }
        }
    }
`);

export const bimWorkOrderChangeOtherDataViewGql = graphql(`
    query bimWorkOrderChangeOtherDataView($workOrderOtherPriceId: Long, $workOrderChangeOtherPriceId: Long) {
        bimWorkOrderChangeOtherData(
            workOrderChangeOtherPriceId: $workOrderChangeOtherPriceId
            workOrderOtherPriceId: $workOrderOtherPriceId
        ) {
            data {
                name
                calculatingType
                calculatingTypeValue
                chapter
                formula
                isGlobalOtherCost
                otherCostLimits {
                    constructionType {
                        id
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    cost
                }
                status
                catalogOtherCostType {
                    id
                    uniqueId
                    name
                    canDelete
                    isSystem
                }
            }
        }
    }
`);
